import { Fragment } from "react";
import { Divider } from "@/scott/ui/elements/divider/divider";
import { TextD2C } from "@/scott/ui/elements/text-d2c/text";

export interface ProductMetaListItem {
  label: string;
  value?: string;
}

export interface ProductMetaListProps {
  items: ProductMetaListItem[];
}

export function ProductMetaList(props: Readonly<ProductMetaListProps>) {
  const visibleItems = props.items.filter((item) => item.value);

  if (visibleItems.length === 0) {
    return null;
  }

  return (
    <dl>
      {visibleItems.map((item, index) => (
        <Fragment key={item.label}>
          {index > 0 && <Divider />}
          <div className="flex justify-between gap-4 py-3">
            <dt>
              <TextD2C style="bold" variant="p-small">
                {item.label}
              </TextD2C>
            </dt>
            <dd className="text-right">
              <TextD2C style="no-mb" variant="p-small">
                {item.value}
              </TextD2C>
            </dd>
          </div>
        </Fragment>
      ))}
    </dl>
  );
}
